module.exports = __webpack_public_path__ + "7679ba36e7c86bae583ffe9b0fa175cd.svg";